import { render, staticRenderFns } from "./GTS200-1.vue?vue&type=template&id=05f40f2b&scoped=true&"
import script from "./GTS200-1.vue?vue&type=script&lang=js&"
export * from "./GTS200-1.vue?vue&type=script&lang=js&"
import style0 from "./GTS200-1.vue?vue&type=style&index=0&id=05f40f2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f40f2b",
  null
  
)

export default component.exports